"use strict";
exports.__esModule = true;
exports.registerDefaultDecorators = registerDefaultDecorators;
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { "default": obj };
}
var _decoratorsInline = require("./decorators/inline");
var _decoratorsInline2 = _interopRequireDefault(_decoratorsInline);
function registerDefaultDecorators(instance) {
  _decoratorsInline2["default"](instance);
}
